import { useThemeStore } from '../../lib/theme/theme-store'
import { SafeBackground } from './SafeBackground'

export function AppBackground({ children }: { children: React.ReactNode }) {
  const activeProfile = useThemeStore((state) => state.getActiveProfile())
  
  return (
    <SafeBackground 
      type={activeProfile.background.type}
      value={activeProfile.background.value}
      patternStyle={activeProfile.background.patternStyle}
      opacity={activeProfile.background.opacity}
      blur={activeProfile.background.blur}
    >
      {children}
    </SafeBackground>
  )
}
